const ckeditor_config = {
  // cloudServices: {
  //   tokenUrl:'https://75927.cke-cs.com/token/dev/b8e182e2e45a2abf1f3fa85315306baefedeea666689af0aa418b35541b1',
  //   uploadUrl: 'https://75927.cke-cs.com/easyimage/upload/',
  // },
};

export { ckeditor_config };
